export const IndustryData = [
  {
    value: '公眾人物、專業人士(其他)',
    text: '公眾人物、專業人士(其他)',
    index: 1,
    subItems: [
      {
        value: '演員、導演',
        text: '演員、導演',
        index: 1
      },
      {
        value: '模特兒',
        text: '模特兒',
        index: 2
      },
      {
        value: '藝人',
        text: '藝人',
        index: 3
      },
      {
        value: '業務、仲介',
        text: '業務、仲介',
        index: 4
      },
      {
        value: '運動員',
        text: '運動員',
        index: 5
      },
      {
        value: '作家',
        text: '作家',
        index: 6
      },
      {
        value: '廚師',
        text: '廚師',
        index: 7
      },
      {
        value: '教練',
        text: '教練',
        index: 8
      },
      {
        value: '諧星',
        text: '諧星',
        index: 9
      },
      {
        value: '舞者',
        text: '舞者',
        index: 10
      },
      {
        value: '設計師',
        text: '設計師',
        index: 11
      },
      {
        value: '表演者',
        text: '表演者',
        index: 12
      },
      {
        value: '虛構人物',
        text: '虛構人物',
        index: 13
      },
      {
        value: '政府官員',
        text: '政府官員',
        index: 14
      },
      {
        value: '記者',
        text: '記者',
        index: 15
      },
      {
        value: '電影角色',
        text: '電影角色',
        index: 16
      },
      {
        value: '音樂家、樂團',
        text: '音樂家、樂團',
        index: 17
      },
      {
        value: '新聞主播',
        text: '新聞主播',
        index: 18
      },
      {
        value: '寵物',
        text: '寵物',
        index: 19
      },
      {
        value: '攝影師',
        text: '攝影師',
        index: 20
      },
      {
        value: '政治家',
        text: '政治家',
        index: 21
      },
      {
        value: '製作人',
        text: '製作人',
        index: 22
      },
      {
        value: '名人',
        text: '名人',
        index: 23
      },
      {
        value: '教師',
        text: '教師',
        index: 24
      },
      {
        value: '角色',
        text: '角色',
        index: 25
      },
      {
        value: '藝術家',
        text: '藝術家',
        index: 26
      },
      {
        value: '演藝產業、媒體',
        text: '演藝產業、媒體',
        index: 27
      },
      {
        value: '生活相關',
        text: '生活相關',
        index: 28
      },
      {
        value: '客服',
        text: '客服',
        index: 29
      },
      {
        value: '美容、時尚',
        text: '美容、時尚',
        index: 30
      },
      {
        value: '法律、會計',
        text: '法律、會計',
        index: 31
      },
      {
        value: '語言、國際',
        text: '語言、國際',
        index: 32
      },
      {
        value: 'IT、電腦',
        text: 'IT、電腦',
        index: 33
      },
      {
        value: '公務員',
        text: '公務員',
        index: 34
      },
      {
        value: '保全、防衛',
        text: '保全、防衛',
        index: 35
      },
      {
        value: '醫療人員',
        text: '醫療人員',
        index: 36
      },
      {
        value: '不動產、建築、土木',
        text: '不動產、建築、土木',
        index: 37
      },
      {
        value: '企業家',
        text: '企業家',
        index: 38
      },
      {
        value: '金融、證券、保險',
        text: '金融、證券、保險',
        index: 39
      },
      {
        value: '教育、學術',
        text: '教育、學術',
        index: 40
      },
      {
        value: '機械、技術、製造',
        text: '機械、技術、製造',
        index: 41
      },
      {
        value: '社會運 動、評論',
        text: '社會運 動、評論',
        index: 42
      },
      {
        value: '美食評論',
        text: '美食評論',
        index: 43
      },
      {
        value: '健康、瘦身',
        text: '健康、瘦身',
        index: 44
      },
      {
        value: '時事評論',
        text: '時事評論',
        index: 45
      },
      {
        value: '旅遊',
        text: '旅遊',
        index: 46
      },
      {
        value: '兩性專家',
        text: '兩性專家',
        index: 47
      },
      {
        value: '體育、運動',
        text: '體育、運動',
        index: 48
      },
      {
        value: '烹飪',
        text: '烹飪',
        index: 49
      },
      {
        value: '自然科學',
        text: '自然科學',
        index: 50
      },
      {
        value: '農業、林業、水產業',
        text: '農業、林業、水產業',
        index: 51
      },
      {
        value: '交通工具、交通',
        text: '交通工具、交通',
        index: 52
      },
      {
        value: '傳統文化',
        text: '傳統文化',
        index: 53
      },
      {
        value: '創業、經營管理',
        text: '創業、經營管理',
        index: 54
      },
      {
        value: '家教',
        text: '家教',
        index: 55
      },
      {
        value: '學生',
        text: '學生',
        index: 56
      },
      {
        value: '公眾人物、專業人士(其他)',
        text: '公眾人物、專業人士(其他)',
        index: 57
      }
    ]
  },
  {
    value: '餐飲',
    text: '餐飲',
    index: 2,
    subItems: [
      {
        value: '中式料理',
        text: '中式料理',
        index: 1
      },
      {
        value: '日式料理',
        text: '日式料理',
        index: 2
      },
      {
        value: '亞洲料理',
        text: '亞洲料理',
        index: 3
      },
      {
        value: '美式料理',
        text: '美式料理',
        index: 4
      },
      {
        value: '異國料理',
        text: '異國料理',
        index: 5
      },
      {
        value: '烘焙類、麵包、糕餅店',
        text: '烘焙類、麵包、糕餅店',
        index: 6
      },
      {
        value: '燒烤類',
        text: '燒烤類',
        index: 7
      },
      {
        value: '鍋類',
        text: '鍋類',
        index: 8
      },
      {
        value: '咖啡簡餐類',
        text: '咖啡簡餐類',
        index: 9
      },
      {
        value: '素食',
        text: '素食',
        index: 10
      },
      {
        value: '速食',
        text: '速食',
        index: 11
      },
      {
        value: '主題特色餐廳',
        text: '主題特色餐廳',
        index: 12
      },
      {
        value: '早餐店',
        text: '早餐店',
        index: 13
      },
      {
        value: '自助餐',
        text: '自助餐',
        index: 14
      },
      {
        value: '小吃店、攤商',
        text: '小吃店、攤商',
        index: 15
      },
      {
        value: '吃到飽',
        text: '吃到飽',
        index: 16
      },
      {
        value: '冰品、飲料',
        text: '冰品、飲料',
        index: 17
      },
      {
        value: '甜點、下午茶',
        text: '甜點、下午茶',
        index: 18
      },
      {
        value: '夜店、酒吧、Live house',
        text: '夜店、酒吧、Live house',
        index: 19
      },
      {
        value: '複合式餐飲',
        text: '複合式餐飲',
        index: 20
      },
      {
        value: '餐飲(其他)',
        text: '餐飲(其他)',
        index: 21
      }
    ]
  },
  {
    value: '購物、零售',
    text: '購物、零售',
    index: 3,
    subItems: [
      {
        value: '服飾、配件、鐘錶',
        text: '服飾、配件、鐘錶',
        index: 1
      },
      {
        value: '飾品、珠寶',
        text: '飾品、珠寶',
        index: 2
      },
      {
        value: '生活用品、傢俱',
        text: '生活用品、傢俱',
        index: 3
      },
      {
        value: '食品、食材',
        text: '食品、食材',
        index: 4
      },
      {
        value: '眼鏡、隱形眼鏡',
        text: '眼鏡、隱形眼鏡',
        index: 5
      },
      {
        value: '美妝店',
        text: '美妝店',
        index: 6
      },
      {
        value: '3C、家電(買賣、維修、包膜)',
        text: '3C、家電(買賣、維修、包膜)',
        index: 7
      },
      {
        value: '百貨、購物中心',
        text: '百貨、購物中心',
        index: 8
      },
      {
        value: '便利商店、超市、大賣場',
        text: '便利商店、超市、大賣場',
        index: 9
      },
      {
        value: '二手店、折扣店',
        text: '二手店、折扣店',
        index: 10
      },
      {
        value: '書店、文具店',
        text: '書店、文具店',
        index: 11
      },
      {
        value: '樂器行',
        text: '樂器行',
        index: 12
      },
      {
        value: '運動用品、腳踏車行',
        text: '運動用品、腳踏車行',
        index: 13
      },
      {
        value: '嬰幼兒、兒童用品',
        text: '嬰幼兒、兒童用品',
        index: 14
      },
      {
        value: '寵物用品店',
        text: '寵物用品店',
        index: 15
      },
      {
        value: '購物、零售(其他)',
        text: '購物、零售(其他)',
        index: 16
      }
    ]
  },
  {
    value: '美容、沙龍',
    text: '美容、沙龍',
    index: 4,
    subItems: [
      {
        value: '髮廊、美髮沙龍',
        text: '髮廊、美髮沙龍',
        index: 1
      },
      {
        value: '美容美體SPA/沙龍、美甲沙龍、按摩',
        text: '美容美體SPA/沙龍、美甲沙龍、按摩',
        index: 2
      },
      {
        value: '美容、沙龍(其他)',
        text: '美容、沙龍(其他)',
        index: 3
      }
    ]
  },
  {
    value: '學校',
    text: '學校',
    index: 5,
    subItems: [
      {
        value: '研究所、大學',
        text: '研究所、大學',
        index: 1
      },
      {
        value: '高中/職、國中',
        text: '高中/職、國中',
        index: 2
      },
      {
        value: '專門學校、技術學院',
        text: '專門學校、技術學院',
        index: 3
      },
      {
        value: '學校社團(學會)、系所',
        text: '學校社團(學會)、系所',
        index: 4
      },
      {
        value: '小學、幼稚園、托兒所',
        text: '小學、幼稚園、托兒所',
        index: 5
      },
      {
        value: '學校(其他)',
        text: '學校(其他)',
        index: 6
      }
    ]
  },
  {
    value: '娛樂、休閒相關',
    text: '娛樂、休閒相關',
    index: 6,
    subItems: [
      {
        value: '電影院',
        text: '電影院',
        index: 1
      },
      {
        value: 'KTV',
        text: 'KTV',
        index: 2
      },
      {
        value: '遊樂中心',
        text: '遊樂中心',
        index: 3
      },
      {
        value: '網咖、漫畫店、影音出借、桌遊店',
        text: '網咖、漫畫店、影音出借、桌遊店',
        index: 4
      },
      {
        value: '展覽會場、藝文中心',
        text: '展覽會場、藝文中心',
        index: 5
      },
      {
        value: '嗜好、進修課程(舞蹈、烹飪、音樂等)',
        text: '嗜好、進修課程(舞蹈、烹飪、音樂等)',
        index: 6
      },
      {
        value: '運動中心、健身房',
        text: '運動中心、健身房',
        index: 7
      },
      {
        value: '遊樂園、主題樂園',
        text: '遊樂園、主題樂園',
        index: 8
      },
      {
        value: '動物園、水族館',
        text: '動物園、水族館',
        index: 9
      },
      {
        value: '美術館、博物館',
        text: '美術館、博物館',
        index: 10
      },
      {
        value: '圖書館',
        text: '圖書館',
        index: 11
      },
      {
        value: '體育館',
        text: '體育館',
        index: 12
      },
      {
        value: '球場(高爾夫球場、棒球場等)',
        text: '球場(高爾夫球場、棒球場等)',
        index: 13
      },
      {
        value: '俱樂部',
        text: '俱樂部',
        index: 14
      },
      {
        value: '名勝古蹟、地標、景點',
        text: '名勝古蹟、地標、景點',
        index: 15
      },
      {
        value: '商圈、夜市',
        text: '商圈、夜市',
        index: 16
      },
      {
        value: '觀光工廠、農場、果園',
        text: '觀光工廠、農場、果園',
        index: 17
      },
      {
        value: '娛樂、休閒相關(其他)',
        text: '娛樂、休閒相關(其他)',
        index: 18
      }
    ]
  },
  {
    value: '生活相關服務',
    text: '生活相關服務',
    index: 7,
    subItems: [
      {
        value: '郵局',
        text: '郵局',
        index: 1
      },
      {
        value: '相親、交友服務',
        text: '相親、交友服務',
        index: 2
      },
      {
        value: '徵信社',
        text: '徵信社',
        index: 3
      },
      {
        value: '通訊電信服務',
        text: '通訊電信服務',
        index: 4
      },
      {
        value: '房屋仲介',
        text: '房屋仲介',
        index: 5
      },
      {
        value: '搬家服務',
        text: '搬家服務',
        index: 6
      },
      {
        value: '水電瓦斯相關',
        text: '水電瓦斯相關',
        index: 7
      },
      {
        value: '第四台相關服務',
        text: '第四台相關服務',
        index: 8
      },
      {
        value: '票券行(如:交通、餐飲)',
        text: '票券行(如:交通、餐飲)',
        index: 9
      },
      {
        value: '公益彩券',
        text: '公益彩券',
        index: 10
      },
      {
        value: '資源回收',
        text: '資源回收',
        index: 11
      },
      {
        value: '攝影工作室、照相館',
        text: '攝影工作室、照相館',
        index: 12
      },
      {
        value: '室內設計',
        text: '室內設計',
        index: 13
      },
      {
        value: '生命禮儀相關',
        text: '生命禮儀相關',
        index: 14
      },
      {
        value: '寵物美容、沙龍',
        text: '寵物美容、沙龍',
        index: 15
      },
      {
        value: '寵物旅館',
        text: '寵物旅館',
        index: 16
      },
      {
        value: '房屋清潔',
        text: '房屋清潔',
        index: 17
      },
      {
        value: '清洗相關服務(衣鞋包)',
        text: '清洗相關服務(衣鞋包)',
        index: 18
      },
      {
        value: '當鋪',
        text: '當鋪',
        index: 19
      },
      {
        value: '鎖匙刻印',
        text: '鎖匙刻印',
        index: 20
      },
      {
        value: '月子中心',
        text: '月子中心',
        index: 21
      },
      {
        value: '裝潢、油漆粉刷',
        text: '裝潢、油漆粉刷',
        index: 22
      },
      {
        value: '影印店、印刷店(名片、海報)',
        text: '影印店、印刷店(名片、海報)',
        index: 23
      },
      {
        value: '出國打工/遊學事務相關代辦',
        text: '出國打工/遊學事務相關代辦',
        index: 24
      },
      {
        value: '物流、運輸',
        text: '物流、運輸',
        index: 25
      },
      {
        value: '社區住宅(管委會)',
        text: '社區住宅(管委會)',
        index: 26
      },
      {
        value: '褓母服務、管家',
        text: '褓母服務、管家',
        index: 27
      },
      {
        value: '保全、物業',
        text: '保全、物業',
        index: 28
      },
      {
        value: '建案',
        text: '建案',
        index: 29
      },
      {
        value: '各類行動工作室',
        text: '各類行動工作室',
        index: 30
      },
      {
        value: '代購服務',
        text: '代購服務',
        index: 31
      },
      {
        value: '生活相關服務(其他)',
        text: '生活相關服務(其他)',
        index: 32
      }
    ]
  },
  {
    value: '醫療相關',
    text: '醫療相關',
    index: 8,
    subItems: [
      {
        value: '醫院',
        text: '醫院',
        index: 1
      },
      {
        value: '整骨、復健治療、國術館',
        text: '整骨、復健治療、國術館',
        index: 2
      },
      {
        value: '牙科診所',
        text: '牙科診所',
        index: 3
      },
      {
        value: '耳鼻喉科診所',
        text: '耳鼻喉科診所',
        index: 4
      },
      {
        value: '醫美診所、整型外科診所',
        text: '醫美診所、整型外科診所',
        index: 5
      },
      {
        value: '婦科診所',
        text: '婦科診所',
        index: 6
      },
      {
        value: '內兒科診所',
        text: '內兒科診所',
        index: 7
      },
      {
        value: '眼科診所',
        text: '眼科診所',
        index: 8
      },
      {
        value: '皮膚科診所',
        text: '皮膚科診所',
        index: 9
      },
      {
        value: '中醫診所',
        text: '中醫診所',
        index: 10
      },
      {
        value: '其他醫院、診所',
        text: '其他醫院、診所',
        index: 11
      },
      {
        value: '寵物診所、動物醫院',
        text: '寵物診所、動物醫院',
        index: 12
      },
      {
        value: '福利安養機構',
        text: '福利安養機構',
        index: 13
      },
      {
        value: '看護服務',
        text: '看護服務',
        index: 14
      },
      {
        value: '藥局',
        text: '藥局',
        index: 15
      },
      {
        value: '醫療器材',
        text: '醫療器材',
        index: 16
      },
      {
        value: '健檢中心、健康諮詢中心',
        text: '健檢中心、健康諮詢中心',
        index: 17
      },
      {
        value: '醫療相關(其他)',
        text: '醫療相關(其他)',
        index: 18
      }
    ]
  },
  {
    value: '補習班相關服務',
    text: '補習班相關服務',
    index: 9,
    subItems: [
      {
        value: '升學、就業補習班',
        text: '升學、就業補習班',
        index: 1
      },
      {
        value: '外語補習班',
        text: '外語補習班',
        index: 2
      },
      {
        value: '安親班',
        text: '安親班',
        index: 3
      },
      {
        value: '函授教育',
        text: '函授教育',
        index: 4
      },
      {
        value: '補習相關服務(其他)',
        text: '補習相關服務(其他)',
        index: 5
      }
    ]
  },
  {
    value: '旅行社、旅館',
    text: '旅行社、旅館',
    index: 10,
    subItems: [
      {
        value: '旅遊社、旅遊服務',
        text: '旅遊社、旅遊服務',
        index: 1
      },
      {
        value: '飯店、旅館、民帕',
        text: '飯店、旅館、民帕',
        index: 2
      },
      {
        value: '旅行社、旅館(其他)',
        text: '旅行社、旅館(其他)',
        index: 3
      }
    ]
  },
  {
    value: '汽機車',
    text: '汽機車',
    index: 11,
    subItems: [
      {
        value: '新車販售',
        text: '新車販售',
        index: 1
      },
      {
        value: '中古車買賣',
        text: '中古車買賣',
        index: 2
      },
      {
        value: '機車販售',
        text: '機車販售',
        index: 3
      },
      {
        value: '車輛保養維修服務',
        text: '車輛保養維修服務',
        index: 4
      },
      {
        value: '汽機車零件',
        text: '汽機車零件',
        index: 5
      },
      {
        value: '汽機車(其他)',
        text: '汽機車(其他)',
        index: 6
      }
    ]
  },
  {
    value: '交通、 租車',
    text: '交通、 租車',
    index: 12,
    subItems: [
      {
        value: '計程車',
        text: '計程車',
        index: 1
      },
      {
        value: '巴士、客運',
        text: '巴士、客運',
        index: 2
      },
      {
        value: '租車服務',
        text: '租車服務',
        index: 3
      },
      {
        value: '捷運站、火車站、高鐵站',
        text: '捷運站、火車站、高鐵站',
        index: 4
      },
      {
        value: '航空、機場',
        text: '航空、機場',
        index: 5
      },
      {
        value: '加油站',
        text: '加油站',
        index: 6
      },
      {
        value: '各式交通資格的教學中心(駕訓班)',
        text: '各式交通資格的教學中心(駕訓班)',
        index: 7
      },
      {
        value: '代理駕駛',
        text: '代理駕駛',
        index: 8
      },
      {
        value: '停車場',
        text: '停車場',
        index: 9
      },
      {
        value: '休息站',
        text: '休息站',
        index: 10
      },
      {
        value: '交通、租車(其他)',
        text: '交通、租車(其他)',
        index: 11
      }
    ]
  },
  {
    value: '婚禮相關',
    text: '婚禮相關',
    index: 13,
    subItems: [
      {
        value: '結婚場地',
        text: '結婚場地',
        index: 1
      },
      {
        value: '婚紗、婚攝、婚禮顧問',
        text: '婚紗、婚攝、婚禮顧問',
        index: 2
      },
      {
        value: '婚禮相關(其他)',
        text: '婚禮相關(其他)',
        index: 3
      }
    ]
  },
  {
    value: '法律、會計事務所',
    text: '法律、會計事務所',
    index: 14,
    subItems: [
      {
        value: '律師事務所',
        text: '律師事務所',
        index: 1
      },
      {
        value: '代書事務所',
        text: '代書事務所',
        index: 2
      },
      {
        value: '會計師事務所',
        text: '會計師事務所',
        index: 3
      },
      {
        value: '稅務記帳士事務所',
        text: '稅務記帳士事務所',
        index: 4
      },
      {
        value: '公證人事務所',
        text: '公證人事務所',
        index: 5
      },
      {
        value: '法律、會計事務所(其他)',
        text: '法律、會計事務所(其他)',
        index: 6
      }
    ]
  },
  {
    value: '銀行、保險、金融',
    text: '銀行、保險、金融',
    index: 15,
    subItems: [
      {
        value: '銀行、信用合作社、農漁會',
        text: '銀行、信用合作社、農漁會',
        index: 1
      },
      {
        value: '保險業',
        text: '保險業',
        index: 2
      },
      {
        value: '銀行、保險、金融(其他)',
        text: '銀行、保險、金融(其他)',
        index: 3
      }
    ]
  },
  {
    value: '其他在地店家',
    text: '其他在地店家',
    index: 16,
    subItems: [
      {
        value: '在地店家(其他)',
        text: '在地店家(其他)',
        index: 1
      }
    ]
  },
  {
    value: '活動',
    text: '活動',
    index: 17,
    subItems: [
      {
        value: '演唱會、音樂會',
        text: '演唱會、音樂會',
        index: 1
      },
      {
        value: '展覽',
        text: '展覽',
        index: 2
      },
      {
        value: '運動賽事',
        text: '運動賽事',
        index: 3
      },
      {
        value: '節慶活動',
        text: '節慶活動',
        index: 4
      },
      {
        value: '表演',
        text: '表演',
        index: 5
      },
      {
        value: '影展、電影相關',
        text: '影展、電影相關',
        index: 6
      },
      {
        value: '講座、體驗課程、營隊',
        text: '講座、體驗課程、營隊',
        index: 7
      },
      {
        value: '活動(其他)',
        text: '活動(其他)',
        index: 8
      }
    ]
  },
  {
    value: '中央行政機關',
    text: '中央行政機關',
    index: 18,
    subItems: [
      {
        value: '政府一級機關(行政院、立法院等)',
        text: '政府一級機關(行政院、立法院等)',
        index: 1
      },
      {
        value: '政府二級機關(教育部、內政部等)',
        text: '政府二級機關(教育部、內政部等)',
        index: 2
      },
      {
        value: '政府三級機關',
        text: '政府三級機關',
        index: 3
      },
      {
        value: '署、局(消防署、警政署等)',
        text: '署、局(消防署、警政署等)',
        index: 4
      },
      {
        value: '分署、分局',
        text: '分署、分局',
        index: 5
      },
      {
        value: '中央行政機關(其他)',
        text: '中央行政機關(其他)',
        index: 6
      }
    ]
  },
  {
    value: '地方行政機關、內部單位',
    text: '地方行政機關、內部單位',
    index: 19,
    subItems: [
      {
        value: '市政府、縣政府(非直轄市)',
        text: '市政府、縣政府(非直轄市)',
        index: 1
      },
      {
        value: '區公所、鄉公所、市公所、鎮公所',
        text: '區公所、鄉公所、市公所、鎮公所',
        index: 2
      },
      {
        value: '警察局、分局、派出所',
        text: '警察局、分局、派出所',
        index: 3
      },
      {
        value: '消防局',
        text: '消防局',
        index: 4
      },
      {
        value: '村、里辦公處',
        text: '村、里辦公處',
        index: 5
      },
      {
        value: '地方行政機關、內部單位(其他)',
        text: '地方行政機關、內部單位(其他)',
        index: 6
      }
    ]
  },
  {
    value: '政黨',
    text: '政黨',
    index: 20,
    subItems: [
      {
        value: '政黨',
        text: '政黨',
        index: 1
      }
    ]
  },
  {
    value: '企業、組織',
    text: '企業、組織',
    index: 21,
    subItems: [
      {
        value: '航太、軍事用品',
        text: '航太、軍事用品',
        index: 1
      },
      {
        value: '汽機車和零件',
        text: '汽機車和零件',
        index: 2
      },
      {
        value: '銀行、金融機關',
        text: '銀行、金融機關',
        index: 3
      },
      {
        value: '生物科技',
        text: '生物科技',
        index: 4
      },
      {
        value: '社區祖織',
        text: '社區祖織',
        index: 5
      },
      {
        value: '電腦、科技',
        text: '電腦、科技',
        index: 6
      },
      {
        value: '顧問、企業服務',
        text: '顧問、企業服務',
        index: 7
      },
      {
        value: '教育',
        text: '教育',
        index: 8
      },
      {
        value: '能源、公共事業',
        text: '能源、公共事業',
        index: 9
      },
      {
        value: '工學、建設',
        text: '工學、建設',
        index: 10
      },
      {
        value: '園藝、農業',
        text: '園藝、農業',
        index: 11
      },
      {
        value: '食品、飲料',
        text: '食品、飲料',
        index: 12
      },
      {
        value: '健康、美容',
        text: '健康、美容',
        index: 13
      },
      {
        value: '醫療、製藥',
        text: '醫療、製藥',
        index: 14
      },
      {
        value: '工業用品',
        text: '工業用品',
        index: 15
      },
      {
        value: '保險公司',
        text: '保險公司',
        index: 16
      },
      {
        value: '房地產、房屋仲介',
        text: '房地產、房屋仲介',
        index: 17
      },
      {
        value: '網路、軟體',
        text: '網路、軟體',
        index: 18
      },
      {
        value: '法律',
        text: '法律',
        index: 19
      },
      {
        value: '媒體、新聞、出版',
        text: '媒體、新聞、出版',
        index: 20
      },
      {
        value: '採礦、資源',
        text: '採礦、資源',
        index: 21
      },
      {
        value: '非營利組織、非政府組織(NGO)',
        text: '非營利組織、非政府組織(NGO)',
        index: 22
      },
      {
        value: '零售、消費者商品',
        text: '零售、消費者商品',
        index: 23
      },
      {
        value: '通訊、電信',
        text: '通訊、電信',
        index: 24
      },
      {
        value: '物流、運輸',
        text: '物流、運輸',
        index: 25
      },
      {
        value: '旅行、休閒',
        text: '旅行、休閒',
        index: 26
      },
      {
        value: '宗教相關',
        text: '宗教相關',
        index: 27
      },
      {
        value: '企業、組織(其他)',
        text: '企業、組織(其他)',
        index: 28
      }
    ]
  },
  {
    value: '品牌、商品',
    text: '品牌、商品',
    index: 22,
    subItems: [
      {
        value: '資訊科技',
        text: '資訊科技',
        index: 1
      },
      {
        value: '家電',
        text: '家電',
        index: 2
      },
      {
        value: '嬰兒、兒童用品',
        text: '嬰兒、兒童用品',
        index: 3
      },
      {
        value: '包包、行李箱',
        text: '包包、行李箱',
        index: 4
      },
      {
        value: '桌遊、玩具',
        text: '桌遊、玩具',
        index: 5
      },
      {
        value: '建材',
        text: '建材',
        index: 6
      },
      {
        value: '攝影',
        text: '攝影',
        index: 7
      },
      {
        value: '汽車',
        text: '汽車',
        index: 8
      },
      {
        value: '服飾',
        text: '服飾',
        index: 9
      },
      {
        value: '工業用設備',
        text: '工業用設備',
        index: 10
      },
      {
        value: ' 電腦',
        text: ' 電腦',
        index: 11
      },
      {
        value: '醫藥品',
        text: '醫藥品',
        index: 12
      },
      {
        value: '3C產品',
        text: '3C產品',
        index: 13
      },
      {
        value: '食品、飲料',
        text: '食品、飲料',
        index: 14
      },
      {
        value: '家具、裝潢',
        text: '家具、裝潢',
        index: 15
      },
      {
        value: '電玩遊戲',
        text: '電玩遊戲',
        index: 16
      },
      {
        value: '健康、美容',
        text: '健康、美容',
        index: 17
      },
      {
        value: '家庭用品',
        text: '家庭用品',
        index: 18
      },
      {
        value: '珠寶、手錶',
        text: '珠寶、手錶',
        index: 19
      },
      {
        value: '廚房、烹飪',
        text: '廚房、烹飪',
        index: 20
      },
      {
        value: '辦公用品',
        text: '辦公用品',
        index: 21
      },
      {
        value: '戶外、運動用品',
        text: '戶外、運動用品',
        index: 22
      },
      {
        value: '園藝用品',
        text: '園藝用品',
        index: 23
      },
      {
        value: '寵物用品',
        text: '寵物用品',
        index: 24
      },
      {
        value: '商品、服務',
        text: '商品、服務',
        index: 25
      },
      {
        value: '網路、軟體',
        text: '網路、軟體',
        index: 26
      },
      {
        value: '工具、設備',
        text: '工具、設備',
        index: 27
      },
      {
        value: '維他命、營養食品',
        text: '維他命、營養食品',
        index: 28
      },
      {
        value: '網站',
        text: '網站',
        index: 29
      },
      {
        value: '酒類',
        text: '酒類',
        index: 30
      },
      {
        value: '品牌、商品(其他)',
        text: '品牌、商品(其他)',
        index: 31
      }
    ]
  },
  {
    value: '書籍',
    text: '書籍',
    index: 23,
    subItems: [
      {
        value: '書籍',
        text: '書籍',
        index: 1
      },
      {
        value: '出版社',
        text: '出版社',
        index: 2
      },
      {
        value: '書籍(其他)',
        text: '書籍(其他)',
        index: 3
      }
    ]
  },
  {
    value: '電影',
    text: '電影',
    index: 24,
    subItems: [
      {
        value: '電影、電影活動',
        text: '電影、電影活動',
        index: 1
      },
      {
        value: '電影獎項',
        text: '電影獎項',
        index: 2
      },
      {
        value: '電影公司',
        text: '電影公司',
        index: 3
      },
      {
        value: '電影(其他)',
        text: '電影(其他)',
        index: 4
      }
    ]
  },
  {
    value: '音樂',
    text: '音樂',
    index: 25,
    subItems: [
      {
        value: '專輯、歌曲、音樂活動',
        text: '專輯、歌曲、音樂活動',
        index: 1
      },
      {
        value: '音樂獎項、排行榜',
        text: '音樂獎項、排行榜',
        index: 2
      },
      {
        value: '唱片公司',
        text: '唱片公司',
        index: 3
      },
      {
        value: '經紀、娛樂公司',
        text: '經紀、娛樂公司',
        index: 4
      },
      {
        value: '音樂(其他)',
        text: '音樂(其他)',
        index: 5
      }
    ]
  },
  {
    value: '體育',
    text: '體育',
    index: 26,
    subItems: [
      {
        value: '體育賽事',
        text: '體育賽事',
        index: 1
      },
      {
        value: '體育聯盟',
        text: '體育聯盟',
        index: 2
      },
      {
        value: '球隊',
        text: '球隊',
        index: 3
      },
      {
        value: '體育(其他)',
        text: '體育(其他)',
        index: 4
      }
    ]
  },
  {
    value: '網站&部落格',
    text: '網站&部落格',
    index: 27,
    subItems: [
      {
        value: '藝術、人文科學',
        text: '藝術、人文科學',
        index: 1
      },
      {
        value: '圖文創作',
        text: '圖文創作',
        index: 2
      },
      {
        value: '兩性關係',
        text: '兩性關係',
        index: 3
      },
      {
        value: '時事議題',
        text: '時事議題',
        index: 4
      },
      {
        value: '美食',
        text: '美食',
        index: 5
      },
      {
        value: '特定嗜好',
        text: '特定嗜好',
        index: 6
      },
      {
        value: '綜合主題',
        text: '綜合主題',
        index: 7
      },
      {
        value: '電腦',
        text: '電腦',
        index: 8
      },
      {
        value: '商業、經濟',
        text: '商業、經濟',
        index: 9
      },
      {
        value: '教育相關',
        text: '教育相關',
        index: 10
      },
      {
        value: '公家機關',
        text: '公家機關',
        index: 11
      },
      {
        value: '新聞、媒體',
        text: '新聞、媒體',
        index: 12
      },
      {
        value: '娛樂',
        text: '娛樂',
        index: 13
      },
      {
        value: '健康、瘦身',
        text: '健康、瘦身',
        index: 14
      },
      {
        value: '家居、園藝',
        text: '家居、園藝',
        index: 15
      },
      {
        value: '旅遊、景點',
        text: '旅遊、景點',
        index: 16
      },
      {
        value: '體育',
        text: '體育',
        index: 17
      },
      {
        value: '在地文化、活動',
        text: '在地文化、活動',
        index: 18
      },
      {
        value: '科學',
        text: '科學',
        index: 19
      },
      {
        value: '社會人文',
        text: '社會人文',
        index: 20
      },
      {
        value: '親子',
        text: '親子',
        index: 21
      },
      {
        value: '網站&部落格(其他)',
        text: '網站&部落格(其他)',
        index: 22
      }
    ]
  },
  {
    value: '電視',
    text: '電視',
    index: 28,
    subItems: [
      {
        value: '電視台',
        text: '電視台',
        index: 1
      },
      {
        value: '電視公司',
        text: '電視公司',
        index: 2
      },
      {
        value: '電視節目、節目活動',
        text: '電視節目、節目活動',
        index: 3
      },
      {
        value: '電視(其他)',
        text: '電視(其他)',
        index: 4
      }
    ]
  },
  {
    value: '雜誌、報紙',
    text: '雜誌、報紙',
    index: 29,
    subItems: [
      {
        value: '雜誌期刊類',
        text: '雜誌期刊類',
        index: 1
      },
      {
        value: '報紙',
        text: '報紙',
        index: 2
      },
      {
        value: '雜誌、報紙(其他)',
        text: '雜誌、報紙(其他)',
        index: 3
      }
    ]
  },
  {
    value: '廣播',
    text: '廣播',
    index: 30,
    subItems: [
      {
        value: '廣播公司',
        text: '廣播公司',
        index: 1
      },
      {
        value: '廣播節目',
        text: '廣播節目',
        index: 2
      },
      {
        value: '廣播電台',
        text: '廣播電台',
        index: 3
      },
      {
        value: '廣播(其他)',
        text: '廣播(其他)',
        index: 4
      }
    ]
  },
  {
    value: '其他媒體',
    text: '其他媒體',
    index: 31,
    subItems: [
      {
        value: '自媒體',
        text: '自媒體',
        index: 1
      },
      {
        value: '媒體(其他)',
        text: '媒體(其他)',
        index: 2
      }
    ]
  }
];
